<template>
<div class="popup" v-cloak v-if="nowPaySchemeShow">
    <div class="content" id="nowPayScheme">
        <div class="title">
              {{$t('language.popup.upgradeAccountPopup.currentPlan')}}
            <div class="icon white-close dialog-close" @click="nowPaySchemeShow=false"></div>
        </div>
        <div class="now-scheme-body" v-loading="isLoading" element-loading-background="#fff" v-if="isLoading" style="height:calc(100% - 80px);"></div>
        <div class="now-scheme-body" v-if="!isLoading">
            <div class="now-scheme-msg">
                <div class="now-scheme-msg-left">
                    <div class="now-scheme-name">{{payInfo.payName}}</div>
                    <div class="now-scheme-tip">{{payInfo.payExtension}}</div>
                </div>
                <div class="now-scheme-msg-right">
                    <div class="now-scheme-price">
                        <span class="price">{{payInfo.currency+payInfo.grossPrice}}</span>
                        <span class="old-price" v-if="payInfo.grossPrice!=payInfo.oldPrice">{{payInfo.currency+payInfo.oldPrice}}</span>
                    </div>
                    <div class="now-scheme-vat" v-if="payInfo.vatPrice!=0" v-html="$t('language.paySystem.nowPayScheme.priceVat',{'currency':payInfo.currency,'vatPrice':payInfo.vatPrice,'percent':payInfo.percent,'netPrice':payInfo.netPrice})"></div>
                </div>
            </div>
            <div class="now-scheme-mid">
                <div class="now-scheme-tips" v-if="payInfo.lastFourNumber" >{{$t('language.paySystem.nowPayScheme.defaultPayment',{"method":payInfo.payMethod,"num":payInfo.lastFourNumber})}}</div>
                <div class="now-scheme-tips" v-else >{{$t('language.paySystem.nowPayScheme.paypalPayment')}}</div>
                <div class="now-scheme-click"><span @click="openClick()">{{$t('language.paySystem.nowPayScheme.changePayment')}}</span></div>
            </div>
            <div class="now-scheme-mid">
                <div class="now-scheme-tips">
                    <span v-if="isSubscribe">{{$t('language.paySystem.nowPayScheme.activated',{"time":(payInfo.nextPayTime)})}}</span>
                    <span v-if="!isSubscribe">{{$t('language.paySystem.nowPayScheme.deactivated',{"time":(payInfo.nextPayTime)})}}</span>
                </div>
                <div class="now-scheme-click">
                    <span v-if="isSubscribe" @click="unsubscribePlan()">{{$t('language.common.unsubscribe')}}</span>
                    <span v-if="!isSubscribe" @click="reSubscription()">{{$t('language.common.reactivate')}}</span>
                </div>
            </div>
            <div class="now-scheme-close">
                <button style="border-radius: 5Px;" @click="nowPaySchemeShow=false">{{$t('language.common.ok')}}</button>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import getCurrencyUtils from '@/js/workspace/get_currency.js';
import commonstate from '@/js/constant.js';
export default {
    data() {
        return {
            nowPaySchemeShow: false,
            user: commonUtils.getUser(),
            payInfo: {
                payMethod: 'Visa',//支付方式
                lastFourNumber: '',//信用卡后四位
                changeUrl: '',//改变支付方式连接
                subId: '',//subsCriptionID
                netPrice: 0,//现在的价格
                oldPrice: 0,//以前的价格
            },
            isSubscribe: true,//是否订阅
            isLoading: true,//是否不显示内容
        }
    },
    methods: {
        getPayInfo () {
            var self = this;
            this.Utils.doCbSubscriptionPostRequest('get_by_purchaseIdV', { purchaseId: self.payInfo.purchaseId }).then(res => {
                //如果请求成功
                if (res.ResultMessage == 'OK') {
                    let json = JSON.parse(res.PurchaseNotification);

                    self.payInfo.changeUrl = json.items[0].recurringBilling.changePaymentSubscriptionUrl;
                    self.payInfo.cancelUrl = json.items[0].recurringBilling.cancellationUrl;

                    self.payInfo.purchaseId = json.purchaseId;
                    self.payInfo.payName = json.items[0].productName;
                    self.payInfo.payExtension = json.items[0].productNameExtension;
                    //购买时价格
                    let currencyId = json.paymentInfo.currencyId;
                    self.payInfo.currency = getCurrencyUtils.getCurrencyByCurrencyId(currencyId);
                    self.payInfo.oldPrice = commonUtils.initPriceFormat(currencyId,json.items[0].customerPrice.productSinglePrice.grossPrice);
                    self.payInfo.grossPrice = commonUtils.initPriceFormat(currencyId,json.items[0].customerPrice.totalSinglePrice.grossPrice);
                    let netPrice = json.items[0].customerPrice.totalSinglePrice.netPrice;
                    let vatPrice = json.items[0].customerPrice.totalSinglePrice.vatPrice;
                    self.payInfo.netPrice = commonUtils.initPriceFormat(currencyId,netPrice);
                    self.payInfo.vatPrice = commonUtils.initPriceFormat(currencyId,vatPrice);
                    self.payInfo.percent = ((vatPrice / netPrice) * 100);
                    self.payInfo.percent = self.payInfo.percent.toFixed(2);
                    //临时处理円改为￥
                    if(self.payInfo.currency=="円"){
                        self.payInfo.currency= "￥";
                    }

                    //是否续订
                    if(json.items[0].recurringBilling.statusId == "ACT"){
                        self.isSubscribe = true;
                    }else{
                        self.isSubscribe = false;
                    }
                    //显示内容
                    self.isLoading = false;
                }
            });
        },
        openClick () {
            if (this.payInfo.changeUrl) {
                window.open(this.payInfo.changeUrl + '?x-mb=14', '_blank');
                this.diffShow = false;
                this.$parent.getUserStatus();
            }
        },
        //取消订阅
        unsubscribePlan() {
            //取消paypel订阅
            if(this.$parent.user.subscrId!=null && this.$parent.user.subscrId.startsWith("I")){
                window.open('https://www.paypal.com/cgi-bin/webscr?cmd=_subscr-find&alias=49QKC8T9BTJDC');
                this.$parent.getUserStatus(); //开始检测用户的状态
                return;
            }  
            //cb关闭和重新订阅共用同一方式
            this.reSubscription();
        },
        reSubscription () {
            // 取得要提交页面的URL
            var action = this.payInfo.cancelUrl;
            commonUtils.packageFormAndSubmit(action, this.payInfo, this.$parent.user);
            this.$parent.getUserStatus(); //开始检测用户的状态
        },
    }
}
</script>

<style>
#nowPayScheme {
    width: 700px;
    /*no*/
    height: 338px;
    /*no*/
}

.now-scheme-body{
    padding: 20Px;
    display: grid;
}

.now-scheme-msg{
    display: flex;
    margin-bottom: 10Px;
}

.now-scheme-msg-left{
    width: 60%;
    float: left;
    display: grid;
}

.now-scheme-msg-right{
    width: 40%;
    float: right;
    display: grid;
    text-align: right;
    padding-right: 20Px;
}

.now-scheme-name{
    color: #333333;
    font-size: 16Px;
    font-weight: 700;
    line-height: 20Px;
}

.now-scheme-tip{
    color: #6f6f6f;
    font-size: 14Px;
    line-height: 22Px;
}

.now-scheme-price{
    line-height: 33Px;
}

.now-scheme-price .price{
    font-size: 30Px;
    color: #5562b4;
}

.now-scheme-price .old-price{
    color: #b8bee6;
    position: unset;
    float: unset;
}

.now-scheme-vat{
    font-size: 14Px;
    color: #a3adbd;
    line-height: 20Px;
}

.now-scheme-mid {
    display: grid;
    line-height: 22Px;
    font-size: 14Px;
    margin: 10Px 0;
}

.now-scheme-mid .now-scheme-tips{
    color: #333333;
}

.now-scheme-mid .now-scheme-click span{
    color: #5562b4;
    cursor: pointer;
}

.now-scheme-mid .now-scheme-click span:hover{
    text-decoration: underline;
}

.now-scheme-close{
    position: absolute;
    bottom: 20Px;
    right: 20Px;
}

.now-scheme-close button{
    width: 110Px;
    height: 30Px;
    background: linear-gradient(to right,#6576df, #8580e7);
}

#nowPayScheme .title{
    background: linear-gradient(to right,#6576df, #8480da);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/pay_system_popups/now_pay_scheme_popups.vue